import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faChevronRight, faRocket, faPaperPlane, faCheck, faClock } from '@fortawesome/free-solid-svg-icons';
import { faSmile, faFrown, faMeh } from '@fortawesome/free-regular-svg-icons';
import {
  setEditClient
} from '../../actions/advisor';
import {
  GOALS,
  LA_TEST,
  RR_TEST,
  BS_TEST,
  LF_TEST,
} from '../../constants.js';
import s from './Client.css';

library.add(faEdit, faChevronRight, faRocket, faPaperPlane, faCheck, faClock, faSmile, faFrown, faMeh);

class Client extends PureComponent {

  constructor(props) {
    super(props);
  }

  openClientTest(clientID) {
    window.open('/?clientID=' + clientID);
  }

  checkIfCompleted(client) {
    const completed = client.tests.map((test) => {
      const complete = client.results.filter((result) => result.name === test);
      return complete.length > 0 ? true : false;
    });
    return completed.includes(true) ? true : false;
  }

  getStatusIcon(test, results) {
    if (results) {
      if (test === GOALS) {
        return (<FontAwesomeIcon icon="check" size="lg" color="#84BD00" />);
      }
      const sortedResults = results.filter((result) => result.name === test);
      if (sortedResults.length > 0) {
        return (<FontAwesomeIcon icon="check" size="lg" color="#84BD00" />);
      }
      return (<FontAwesomeIcon icon="clock" size="lg" color="#F68D2E" />);
    } else {
      return (<FontAwesomeIcon icon="clock" size="lg" color="#F68D2E" />);
    }
  }

  getStatusIconGoals(client) {
    if (client) {
      let hasGoal = false;
      if(client.retireMonthlyIncome && client.retireMonthlyIncome > 0) {
        hasGoal = true;
      }
      if (hasGoal) {
        return (<FontAwesomeIcon icon="check" size="lg" color="#84BD00" />);
      }
      return (<FontAwesomeIcon icon="clock" size="lg" color="#F68D2E" />);
    } else {
      return (<FontAwesomeIcon icon="clock" size="lg" color="#F68D2E" />);
    }
  }

  getStatusIconPortfolio(client) {
    if (client) {
      let hasPort = false;
      if(client.holdings && client.holdings.length > 0) {
        hasPort = true;
      }
      if (hasPort) {
        return (<FontAwesomeIcon icon="check" size="lg" color="#84BD00" />);
      }
      return (<FontAwesomeIcon icon="clock" size="lg" color="#F68D2E" />);
    } else {
      return (<FontAwesomeIcon icon="clock" size="lg" color="#F68D2E" />);
    }
  }

  renderProgress() {
    const {
      client,
    } = this.props;

    return (
      <div className={s.clientProgress}>
        <div className={s.testStatus}>
          {this.getStatusIconGoals(client)}&nbsp;&nbsp;Goals 
        </div>
        <div className={s.testStatus}>
          {this.getStatusIconPortfolio(client)}&nbsp;&nbsp;Portfolio 
        </div>
        <div className={s.testStatus}>
          {this.getStatusIcon(LA_TEST, client.results)}&nbsp;&nbsp;Loss Aversion
        </div>
        <div className={s.testStatus}>
          {this.getStatusIcon(BS_TEST, client.results)}&nbsp;&nbsp;Behavioral Stress
        </div>
        <div className={s.testStatus}>
          {this.getStatusIcon(RR_TEST, client.results)}&nbsp;&nbsp;Present Bias
        </div>
        <div className={s.testStatus}>
          {this.getStatusIcon(LF_TEST, client.results)}&nbsp;&nbsp;Loss Frequency
        </div>
      </div>
    );
  }

  getChart(client, port) {
    return {
      color: ['#0047BB', '#00A9E0'],
      //color: ['#2d78d3', '#d3352d'],
      series: [
        {
          name: 'asset class',
          silent: true,
          type: 'pie',
          radius: ['80%', '100%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: [
            { value: 70, name: 'equity' },
            { value: 30, name: 'fixed income' }
          ]
        }
      ]
    };
  }

  getChart2(client, port) {
    let colors =  ['#76a915', '#289919', '#76a915','#f4cc1a', '#fca214', '#f25116', '#ce0012', '#289919'];
    if(port === 'current') {
      colors =  ['#f4cc1a', '#289919', '#76a915','#f4cc1a', '#fca214', '#f25116', '#ce0012', '#289919'];
    }
    return {
      color: colors,
      //color: ['#2d78d3', '#d3352d'],
      series: [
        {
          name: 'options',
          silent: true,
          type: 'pie',
          radius: ['85%', '100%'],
          startAngle: 23,
          avoidLabelOverlap: false,
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 2,
          },
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: [
            { value: 70, name: '1' },
            { value: 70, name: '2' },
            { value: 70, name: '3' },
            { value: 70, name: '4' },
            { value: 70, name: '5' },
            { value: 70, name: '6' },
            { value: 70, name: '7' },
            { value: 70, name: '8' },
          ]
        },
        {
          name: 'options',
          silent: true,
          type: 'pie',
          radius: ['0%', '85%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: [
            { value: 100, name: '1' },
          ]
        }
      ]
    };
  }

  renderResults() {
    const {
      client,
    } = this.props;

    let hasProposed = false;
    if(client.firstName === 'Tim') {
      hasProposed = true;
    }

    return (
      <div className={s.clientResults}>
        <div className={s.current}>
          <div>
            <ReactEcharts option={ this.getChart(client, 'current') } style={{ height: 154 }} />
          </div>
          {/* <FontAwesomeIcon icon={['far','meh']} size="sm" color="#FFF" /> */}
          <div className={s.currentOverlay}><span style={{color:'#f4cc1a'}}>45</span></div>
          <div className={s.clientPortsName}>CLIENT PORTFOLIO</div>
        </div>
        <div className={s.proposed}>
          { hasProposed &&
            <div>
              <div className={s.proposedContent}>
                <ReactEcharts option={ this.getChart(client, 'proposed') } style={{ height: 154 }} />
              </div>
              {/* <FontAwesomeIcon icon={['far','smile']} size="sm" color="#FFF" /> */}
              <div className={s.proposedOverlay}><span style={{color:'#76a915'}}>78</span></div>
              <div className={s.clientPortsName}>PROPOSED MODEL</div>
            </div>
          }
          { !hasProposed &&
            <div>
              <div className={s.proposedOverlayOK}>
                <FontAwesomeIcon icon="check" size="lg" color="#84BD00" />
              </div>
              <div className={s.proposedOverlaySub}>
                Portfolio is Optimal
              </div>
            </div>
          }
        </div>
        { hasProposed && false &&
          <div className={s.differenceOverlay}>+35</div>
        }
      </div>
    );
  }

  render() {
    const {
      client,
      setEditClient,
    } = this.props;

    // const isComplete = this.checkIfCompleted(client);
    let isComplete = false;
    // if(client.firstName === 'Dave' || client.firstName === 'Tim') {
    //   isComplete = true;
    // }

    return (
      <div className='col-lg-4 col-md-12'>
        <div className={s.clientCard}>
          <div className={'row'}>
            <div className={'col-md-9'}>
              <div className={s.clientTitleName}>
                {client.firstName} {client.lastName}
              </div>
              <div className={s.clientEmail}>
                {client.email}
              </div>
            </div>
            <div className={'col-md-3'}>
              <div className={s.clientTitleView} onClick={() => setEditClient(client)}>
                <FontAwesomeIcon icon="edit" size="1x"/>
              </div>
            </div>
          </div>
          <div className={'row'}>
            <div className={'col-md-12'}>
              <div className={s.clientNBA}>
              This is your next best action.
              </div>
            </div>
          </div>
          {!isComplete &&
          <div className={'row'}>
            <div className={'col-lg-6'}>
              <div className={s.clientAction} onClick={() => this.openClientTest(client.id)}>
              Launch Tools <FontAwesomeIcon icon="rocket" size="1x"/>
              </div>
            </div>
            <div className={'col-lg-6'}>
              <div className={s.clientAction}>
              Send Invitation <FontAwesomeIcon icon="paper-plane" size="1x"/>
              </div>
            </div>
          </div>
          }
          {isComplete &&
          <div className={'row'}>
            {/* <div className={'col-md-6'} style={{paddingRight:'1px'}}>
              <div className={s.clientPorts}>
              CLIENT PORTFOLIO
              </div>
            </div>
            <div className={'col-md-6'} style={{paddingLeft:'1px'}}>
              <div className={s.clientPorts}>
              PROPOSED MODEL
              </div>
            </div> */}
            <div className={'col-md-12'}>
              <div className={s.clientPorts}>
              BEHAVIORAL PREFERENCES
              </div>
            </div>
          </div>
          }
          <div className={s.clientContent}>
            {!isComplete && this.renderProgress()}
            {isComplete && this.renderResults()}
          </div>
        </div>
      </div>
    );
  }
}
// onClick={() => setEditClient(client)}
function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps, {
  setEditClient,
})(Client);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/Client.js